<template>
    <div>
        <app-text
            label="Nachname"
            :data-source="'deha.user.misc.team.' + listitemId + '.data.last_name'"
            :data-default="{ type: 'source', value: 'deha.user.misc.contact_person.last_name' }"
            required
            :maxlength="255"
        ></app-text>

        <app-text
            label="Vorname"
            :data-source="'deha.user.misc.team.' + listitemId + '.data.first_name'"
            :data-default="{ type: 'source', value: 'deha.user.misc.contact_person.first_name' }"
            required
            :maxlength="255"
        ></app-text>

        <app-text
            label="Position im Unternehmen"
            :data-source="'deha.user.misc.team.' + listitemId + '.data.position'"
            :data-default="{ type: 'raw', value: 'Geschäftsführer' }"
            :maxlength="255"
        ></app-text>

        <app-text
            label="Standort"
            :data-source="'deha.user.misc.team.' + listitemId + '.data.location'"
            :data-default="{ type: 'source', value: 'deha.user.ort' }"
            :maxlength="255"
        ></app-text>

        <app-filepicker
            label="Mitarbeiterbild"
            :data-source="'deha.user.misc.team.' + listitemId + '.data.image'"
            :data-default="{ type: 'file' }"
            file-namespace="images/team/default"
            accept=".jpg,.png,.gif"
        ></app-filepicker>

        <app-text
            label="Telefonnummer"
            :data-source="'deha.user.misc.team.' + listitemId + '.data.phone'"
            :data-default="{ type: 'source', value: 'deha.user.telefon' }"
            pattern="^(([+]{1,2}[0-9]{2,3})|[0]{1})[0-9]{0,10}[\(]{0,1}[0-9]{1,10}[\)]{0,1}[0-9]{1,10}[\s\|\/\|\-]{0,1}[0-9]{2,10}[\s\|\/\|\-]{0,1}[0-9]{0,10}$"
            autoformat="phone"
            :maxlength="255"
        ></app-text>

        <app-text
            label="E-Mail-Adresse"
            :data-source="'deha.user.misc.team.' + listitemId + '.data.email'"
            :data-default="{ type: 'source', value: 'deha.user.email' }"
            pattern="^\S+@\S+\.\S{2,8}$"
            :maxlength="255"
        ></app-text>
    </div>
</template>

<script>
import Text from '@/components/fields/simple/Text.vue';
import Filepicker from '@/components/fields/complex/Filepicker.vue';

export default {
    data() {
        return {};
    },
    methods: {},
    computed: {},
    mounted() {
        this.$emit('controlhead', {
            title: this.$helpers.uiText('R048'),
            help: this.$helpers.uiText('R049'),
            removeText: this.$helpers.uiText('R050')
        });
    },
    props: {
        moduleId: String,
        listitemId: String
    },
    components: {
        'app-text': Text,
        'app-filepicker': Filepicker
    }
};
</script>
